<template>
  <div class="contact-company-wrapper">
    <ul
      class="accordion accordion-customize"
      data-accordion
      data-deep-link="true"
      data-allow-all-closed="true"
      data-multi-expand="true"
      data-update-history="true"
      data-deep-link-smudge="500"
      id="contact-company-accordion"
    >
      <li
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title"><span>{{ $t('contact.company') }}</span></a>
        <div
          class="accordion-content"
          data-tab-content
        >
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>{{ $t('company.basic.companyName') }}</th>
                <th>{{ $t('company.contactTable.title') }}</th>
                <th>{{ $t('company.contactTable.department') }}</th>
                <th v-if="isEngineer">{{ $t('company.contactTable.propPeople') }}</th>
                <th v-if="contactId && isEngineer" />
              </tr>
            </thead>
            <tbody>
              <template v-if="contactId">
                <tr
                  v-for="(item, index) in deep(currentContact, 'companies')"
                  :key="index"
                >
                  <td>{{ item.type === dummyCompanyType ? $t('emptyValue') : item.id }}</td>
                  <td><a
                    class="company-name"
                    :class="{'link': isEngineer && item.type !== dummyCompanyType}"
                    @click="navToCompanyView(item.id, item.type)"
                  >{{ item.name }}</a></td>
                  <td>
                    <input
                      v-if="allowEdit"
                      type="text"
                      :value="deep(item, 'CompanyContact.title')"
                      @change="event => updatePathField(index, 'title', event.target.value)"
                      v-hkldinput
                    >
                    <div v-else>{{ deep(item, 'CompanyContact.title') }}</div>
                  </td>
                  <td>
                    <input
                      v-if="allowEdit"
                      type="text"
                      :value="deep(item, 'CompanyContact.department')"
                      @change="event => updatePathField(index, 'department', event.target.value)"
                      v-hkldinput
                    >
                    <div v-else>{{ deep(item, 'CompanyContact.department') }}</div>
                  </td>
                  <td v-if="isEngineer">
                    <input
                      id="checkBox"
                      type="checkbox"
                      v-hkldinput
                      :disabled="!allowEdit"
                      :checked="deep(item, 'CompanyContact.isPropertyPerson') ? 'checked' : ''"
                      @change="updatePathField(index, 'isPropertyPerson', !deep(item, 'CompanyContact.isPropertyPerson'))"
                    >
                  </td>
                  <td
                    class="icon-remove"
                    v-if="isEngineer"
                  >
                    <i
                      class="fa fa-times-thin"
                      v-if="allowEdit"
                      @click="openDeleteConfirm(index)"
                    />
                  </td>
                </tr>
              </template>
              <tr v-else>
                <td>{{ currentCompany.type === dummyCompanyType ? $t('emptyValue') : currentCompany.id }}</td>
                <td>{{ currentCompany.name }}</td>
                <td>
                  <input
                    type="text"
                    v-hkldinput
                    v-model="contactCompany.title"
                  >
                </td>
                <td>
                  <input
                    type="text"
                    v-hkldinput
                    v-model="contactCompany.department"
                  >
                </td>
                <td v-if="isEngineer">
                  <input
                    id="checkBox"
                    type="checkbox"
                    v-hkldinput
                    v-model="contactCompany.isPropertyPerson"
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </li>
    </ul>
    <ActionConfirmModal
      ref="deleteConfirmModal"
      :modalId="delConfModalId"
      :confirmTitle="$t('deleteConfirmMsg')"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import mutationTypes from '@/store/mutation-types'
import ActionConfirmModal from '@/controls/ActionConfirmModal'
import i18n from '@/utils/i18n'
import navigation from '@/utils/navigation'
import { companyType } from '@/utils/locale'

export default {
  name: 'ContactCompany',
  props: {
    allowEdit: Boolean,
    contactCompany: Object,
  },
  data () {
    return {
      roleOptions: [
        i18n.t('company.contactTable.emergency'),
        i18n.t('company.contactTable.ecircular'),
      ],
      deep,
      contactId: '',
      delConfModalId: `contactCompany-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`,
      dummyCompanyType: companyType.D,
    }
  },
  components: {
    ActionConfirmModal,
  },
  methods: {
    ...mapMutations('ccd', {
      updateContactPathField: mutationTypes.CONTACT_UPDATE_PATH_FIELD,
      removeContactCompany: mutationTypes.CONTACT_REMOVE_COMPANY,
    }),

    updatePathField (companyIndex, fieldName, newValue) {
      const path = this.getContactCompanyFieldPath(companyIndex, fieldName)
      this.updateContactPathField({path, newValue})
    },

    getContactCompanyFieldPath (companyIndex, fieldName) {
      const path = ['companies', companyIndex, 'CompanyContact']
      return (fieldName !== null) ? [...path, fieldName] : path
    },

    openDeleteConfirm (index) {
      this.$refs.deleteConfirmModal.open(this.removeFromVuex, [index])
    },

    removeFromVuex (index) {
      this.removeContactCompany({index})
    },
    navToCompanyView (id, type) {
      if (this.isEngineer && type !== companyType.D) {
        navigation.toPage('companyView', { id })
      }
    },
  },
  computed: {
    ...mapGetters('ccd', ['currentContact']),
    ...mapGetters('ccd', ['currentCompany']),
    ...mapGetters('user', ['isEngineer']),
  },
  mounted () {
    this.contactId = this.$router.currentRoute.params.id

    if (!this.contactCompanyAccordion) {
      this.contactCompanyAccordion = new Foundation.Accordion(
        $('#contact-company-accordion'),
      )
    }
  },

  destroyed () {
    if (this.contactCompanyAccordion) {
      this.contactCompanyAccordion.destroy()
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/tender/view";
@import "~styles/accordion";
@import "~styles/table";
@import '~styles/icon_remove';

table td input[type="text"] {
  height: 40px;
}
.company-name {
  color: #0C3A58;
  cursor: unset;
}

.company-name.link {
  text-decoration: underline;
  cursor: pointer;
}
</style>
